import { cn } from "@/lib/utils";
import { Unit } from "@/lib/sticker";
import { useTranslation } from "@/lib/i18n";

interface UnitSelectorProps {
  unit: Unit;
  onUnitChange: (unit: Unit) => void;
}

export const UnitSelector = ({ unit, onUnitChange }: UnitSelectorProps) => {
  const t = useTranslation();

  return (
    <div className="flex border border-border/50 rounded-sm overflow-hidden h-7 w-16">
      <button
        className={cn(
          "flex-1 text-xs transition-colors cursor-pointer",
          unit === "mm"
            ? "bg-primary text-primary-foreground"
            : "bg-background hover:bg-muted text-muted-foreground",
        )}
        onClick={() => onUnitChange("mm")}
      >
        {t.units.mm}
      </button>
      <button
        className={cn(
          "flex-1 text-xs transition-colors border-l border-border/50 cursor-pointer",
          unit === "cm"
            ? "bg-primary text-primary-foreground"
            : "bg-background hover:bg-muted text-muted-foreground",
        )}
        onClick={() => onUnitChange("cm")}
      >
        {t.units.cm}
      </button>
    </div>
  );
};
